import { ArrowsDownUp, X } from "@phosphor-icons/react/dist/ssr";
import React, { useState } from "react";
import { Drawer, DrawerClose, DrawerContent, DrawerTitle } from "../ui/drawer";

export default function SortMobile({ sortOption, onChange, options = [] }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type='button'
        onClick={() => setOpen(true)}
        className='inline-flex items-center justify-center flex-shrink-0 text-white border rounded-md size-9 bg-white/5 border-white/5'
      >
        {/* Label Here */}
        <ArrowsDownUp className='text-base' weight='bold' />
      </button>

      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerContent
          aria-describedby={undefined}
          showHandle={false}
          className='p-4 pt-0 bg-gray-50 text-background rounded-t-3xl'
        >
          <DrawerTitle />

          <div className='flex items-center justify-between pb-3 mt-4 text-center border-b border-black/10'>
            <div className='flex items-center justify-start w-12'></div>
            <span className='flex-1 text-lg font-semibold tracking-tight'>
              Sort by
            </span>
            <div className='flex items-center justify-end w-12'>
              <DrawerClose asChild>
                <button type='button'>
                  <X weight='bold' className='size-5 opacity-40' />
                </button>
              </DrawerClose>
            </div>
          </div>

          <div className='flex flex-col pt-3'>
            {options.map((option) => (
              <button
                key={option.value}
                type='button'
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
                className={`text-left py-2.5 font-medium px-3 rounded-lg ${
                  sortOption === option.value ? "bg-black/5" : ""
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
}
